import { ChangeDetectorRef, Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { TimelineShift, UnassignedShift } from '@wilson/interfaces';
import { ShiftMultiSelectHelperService } from '@wilson/shift-timeline/assignments-gantt-chart';
import {
  DragAndDropModeService,
  TimelineHelperService,
} from '@wilson/shift-timeline/services';
import { NzMessageService } from 'ng-zorro-antd/message';
import { firstValueFrom } from 'rxjs';
import { TimelineCommonOperationsService } from '../../../services/timeline-common-operations.service';
import { TimelineShiftDragAndDropDirectiveHelperService } from '../../../services/timeline-shift-drag-and-drop-directive-helper.service';

@Injectable()
export class UnassignedCellViewShiftsWithoutActivitiesDragHandlerService {
  private readonly nzMessageService = inject(NzMessageService);
  private readonly translate = inject(TranslateService);
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly store = inject(Store);
  private readonly dragAndDropModeService = inject(DragAndDropModeService);
  private readonly timelineShiftDragAndDropDirectiveHelperService = inject(
    TimelineShiftDragAndDropDirectiveHelperService,
  );
  private readonly shiftMultiSelectHelperService = inject(
    ShiftMultiSelectHelperService,
  );
  private readonly timelineCommonOperationsService = inject(
    TimelineCommonOperationsService,
  );
  private readonly timelineHelperService = inject(TimelineHelperService);

  async dragStart(
    shift: UnassignedShift,
    hasUpdateShiftPermission: boolean,
    isAssignmentMode: boolean,
  ): Promise<void> {
    this.timelineShiftDragAndDropDirectiveHelperService.setIsTooltipVisible(
      false,
    );
    if (hasUpdateShiftPermission) {
      if (!isAssignmentMode) {
        this.dragAndDropModeService.toggleAssignmentMode();
      }

      this.timelineShiftDragAndDropDirectiveHelperService.initiateCellViewDragAndDrop(
        true,
      );
      this.shiftMultiSelectHelperService.clearSelection();

      try {
        const shiftWithActivities = await firstValueFrom(
          this.timelineCommonOperationsService.fetchShiftWithTranslatedActivityCategoryAndSortActivities(
            shift.id,
          ),
        );
        if (shiftWithActivities) {
          setTimeout(() => {
            this.dragAndDropModeService.setDraggingShiftV2({
              ...shiftWithActivities,
              isHighlighted: false,
            } as TimelineShift);
          });
        }
      } catch (error) {
        this.nzMessageService.error(this.translate.instant('general.error'));
        console.error(error);
      }
    } else {
      this.timelineHelperService.informUserHasNoPermissionsToMoveEntity();
      setTimeout(() => {
        this.timelineShiftDragAndDropDirectiveHelperService.setIsTooltipVisible(
          true,
        );
      }, 600);
    }
  }

  dragEnd(): void {
    this.timelineShiftDragAndDropDirectiveHelperService.handleCellViewDragEnd();
    this.dragAndDropModeService.setDraggingShiftV2(null);
    this.cdRef.detectChanges();
  }
}
